import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './components/App';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import './index.less';

const root = document.getElementById('root') as HTMLElement;
ReactDOM.render(
  <HashRouter>
    <App />
  </HashRouter>
  , root);